import { v4 as uuid } from "uuid";
const generateId = () => uuid();
export default generateId;
